import { Container } from '../components/Container'
import EmbedHubSpotForm from '../components/EmbedHubSpotForm'
import HeroHeader from '../components/HeroHeader'
import { GeneralAPI } from '../apis/GeneralAPI'

export function GetFreeSamples({ data }) {
    return (
        <div>
            <HeroHeader title={'Get Free Samples'} meta={data?.yoast_head} />
            <Container>
                <div className="min-h-full flex justify-center">
                    <div className="max-w-lg w-full">
                        <EmbedHubSpotForm
                            region="na1"
                            portalId="21994206"
                            formId="f9b4c83e-a86e-410c-902f-28611eb2f74f"
                            formName="Get Free Samples"
                        />
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default GetFreeSamples

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/get-free-samples')
    const data = page ? page[0] : {}

    return {
        props: { data },
        revalidate: 10, // In seconds
    }
}
